import logo from './logo.svg';
import './App.css';
import Main from './remover/Main';
import Ui from './remover/Ui';

function App() {
  return (
    <div>
      <Main/>
    </div>
  );
}

export default App;
